<template>
    <div class="video-container" v-if="isVisible">
        <div
            :class="containerClass(1)"
            :data-position="1"
            v-dragula
            drake="first"
        >
            <!-- The video player is only visible in one of the four video positions -->
            <VideoContainer
                v-bind="floatingVideoStream"
                :isPinned="false"
                @videoPinClick="pinVideo"
                @videoCloseClick="closeFloatingStream"
                @toggleSound="toggleFloatingVideoSound"
            />
        </div>
        <div
            :class="containerClass(2)"
            :data-position="2"
            v-dragula
            drake="first"
        />
        <div
            :class="containerClass(3)"
            :data-position="3"
            v-dragula
            drake="first"
        />
        <div
            :class="containerClass(4)"
            :data-position="4"
            v-dragula
            drake="first"
        />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { routeNames } from '@app/router';
    import VideoContainer from '@modules/sportOffer/sports/content/components/VideoContainer.vue';

    export default {
        data() {
            return {
                isDragging: false,
            };
        },
        created() {
            this.initializeDnDEventBus();
        },
        computed: {
            ...mapGetters('ui/sportOffer', [
                'floatingVideoStream',
            ]),
            isVisible() {
                return this.floatingVideoStream && this.isOnSportRoute;
            },
            isOnSportRoute() {
                const routeName = this.$router.currentRoute.name;
                return [
                    routeNames.landing,
                    routeNames.sportOffer,
                    routeNames.live,
                ].includes(routeName);
            },
            shadowStyle() {
                return {
                    height: this.draggableHeight,
                };
            },
        },
        methods: {
            ...mapActions('ui/sportOffer', [
                'pinVideo',
                'closeFloatingStream',
                'toggleFloatingVideoSound',
            ]),
            containerClass(index) {
                const classNames = ['drop-container', `drop-container-${index}`];
                if (this.isDragging) {
                    classNames.push('drop-container-is_dragging');
                }
                return classNames;
            },
            initializeDnDEventBus() {
                const dragula = this.$dragula;
                dragula.createService({
                    name: 'first',
                    drakes: {
                        first: {
                            copy: false,
                            revertOnSpill: true,
                        }
                    },
                });
                this.service = this.$dragula.services[0];

                this.service.eventBus.$on('drag', () => {
                    this.isDragging = true;
                });
                this.service.eventBus.$on('dragend', () => {
                    this.isDragging = false;
                });
                window.service = this.service;
            }
        },
        components: {
            VideoContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/VideoOverlayContainer.vue